import * as React from "react";
import {
  ComboBox,
  ComboBoxFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { Error, Hint, Label } from "@progress/kendo-react-labels";
import { CgDanger } from "react-icons/cg";
const delay = 300;

const FormFilterSelectionField = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    value,
    onChange,
    options,
    textField = "label",
    wrapperStyle,
    wrapperClassName,
    name,
    suggest=false,
    astrike = false,
    
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);
  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const [data, setData] = React.useState(options);
  const [loading, setLoading] = React.useState(false);
  const timeout = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    setData(options);
  }, [options]);

  const filterData = (filter: FilterDescriptor) => {
    const data = options?.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event: ComboBoxFilterChangeEvent) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setData(filterData(event.filter));
      setLoading(false);
    }, delay);

    setLoading(true);
  };

  const handleSelect = (event: any) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  let initialValue = options?.find((option: any) => option.value === value);

  return (
    <>
      <FieldWrapper style={wrapperStyle} className={wrapperClassName}>
        <Label editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label} {astrike && <span style={{ color: "red" }}>*</span>}
        </Label>
        <ComboBox
          ariaLabelledBy={labelId}
          size={"large"}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={id}
          disabled={disabled}
          {...others}
          data={data}
          name={name}
          suggest={suggest}
          value={initialValue || null}
          filterable={true}
          onFilterChange={filterChange}
          loading={loading}
          textField={textField}
          defaultValue={value}
          onChange={handleSelect}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error className="d-flex justify-content-end" id={errorId}>
            <span
              className="d-flex align-items-center"
              style={{
                background: "#DF4957",
                color: "white",
                padding: "1px 8px 1px 5px",
                borderRadius: 10,
                gap: 5,
              }}
            >
              <CgDanger /> {validationMessage}
            </span>
          </Error>
        )}
      </FieldWrapper>
    </>
  );
};

export default FormFilterSelectionField;
